import { useNavigate, useParams } from "react-router-dom";
import { labelsSchedulingColumnsSchedule } from "./LabelsSchedulingColumns";
import React, { useEffect } from "react";
import { DtGrid2 } from "../common/DtGrid2";
import { IRootState } from "../../types/redux/IRootStore";
import { useSelector } from "react-redux";
import { ReduxStatePalletSearchSort } from "../../types/redux/reduxStatePalletSearchSort";
import { DtGridPropsOptions2 } from "../../types/dtGridPropsOptions2";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { LineWoSchedule } from "../../types/lineWoSchedule";
import {
    changeScheduleOrderRedux,
    clearSchedulesRedux,
    deleteScheduleRedux,
    getSchedulesRedux,
    getWorkordersRedux,
    saveScheduleRedux,
    setSelectedScheduleEndDateRedux,
    setSelectedScheduleRedux,
    setSelectedScheduleStartDateRedux,
    setSelectedWorkorderRedux
} from "../../redux/slices/schedules.feature";
import { useAppDispatch } from "../../redux/hooks";
import { ReactSelectStyle } from "../common/rectSelectStyle";
import ReactSelectWrapper from "../common/ReactSeletWrapper";
import _ from "lodash";
import FormInputText from "../common/FormInputText";
import { translateString } from "../../translations/gridTranslationHelper";
import DateSelector3 from "../common/DateSelector3";
import moment from "moment";
import { WorkorderItem } from "../../types/workorderItem";
import { truncateString } from "../../aplUtils/stringUtills";

export default function LabelsScheduling() {
    const params = useParams<{ lineId: string }>();
    const lineId = parseInt(params.lineId ?? "0");

    const [scheduleGridFilters, setScheduleGridFilters] = React.useState({});
    const [scheduleGridSort, setScheduleGridSort] = React.useState<ReduxStatePalletSearchSort>({ field: ["userName"], direction: ["asc"] });
    const [scheduleGridPage, setScheduleGridPage] = React.useState(1);
    // const [scheduleEndDate, setScheduleEndDate] = React.useState<Date | null>(null);

    const schedulesRedux = useSelector((state: IRootState) => state.schedules);
    const dispatch = useAppDispatch();
    const aplSettings = AplSettingsSelector();
    const navigate = useNavigate();

    const schedulesGridOptions: DtGridPropsOptions2 = {
        data: schedulesRedux.schedules,
        columnData: labelsSchedulingColumnsSchedule(aplSettings.culture, aplSettings.isUsSite),
        defaultSort: {
            field: ["scheduleOrder"],
            direction: ["desc"]
        },
        selectType: "single",
        colouring: true,
        headerFilters: true,
        setSelectedItems: function (x: LineWoSchedule[]) {
            dispatch(setSelectedScheduleRedux(x));
        },
        selectedItems: schedulesRedux.selectedSchedule,
        tableName: "tblLablSchedule",
        tableClass: "tbl-labelling-schedule height-40rem",
        paging: true,
        showSpinner: false,
        rowId: "operationId",
        loading: false,
        pageLength: 20,
        sort: scheduleGridSort,
        filters: scheduleGridFilters,
        setFilters: (x: any) => {
            setScheduleGridFilters(x);
        },
        setSort: (x: any) => {
            setScheduleGridSort(x);
        },
        setPage: (x: number) => {
            setScheduleGridPage(x);
        },
        page: scheduleGridPage
    };

    let getBatchesText = (workorderItem: WorkorderItem) =>
        {
            let batches = workorderItem?.workorderBatches?.length > 0
                ? truncateString(
                    workorderItem.workorderBatches
                        .map(x => x.batch)
                        .sort()
                        .reverse()
                        .join(", "),
                    24
                ).truncated
                : "";
            return batches === "" ? "No Batch" : batches;
        };

    const selectableOrders = schedulesRedux.workorders; //.filter(x => !schedulesRedux.schedules.map(y => y.operationId).includes(x.operationId));
    const ordersDropdownData = _.sortBy(
        selectableOrders.map((x: WorkorderItem, y) => ({
            value: x.operationId,
            label: `${x.workorder} - ${getBatchesText(x)} - ${x.materialSapCode} ${x.description}`
        })),
        x => x.label
    );

    const selectedSchedule = schedulesRedux.selectedSchedule.length === 1 ? schedulesRedux.selectedSchedule[0] : null;

    useEffect(() => {
        dispatch(getSchedulesRedux(lineId));
        dispatch(getWorkordersRedux(lineId));
        return () => {
            dispatch(clearSchedulesRedux());
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <h1>
                {translateString("scheduleWorkOrder", aplSettings.culture)}{" "}
                {params.lineId != null ? aplSettings.lines.find(x => x.lineId === Number.parseInt(params.lineId!))?.lineDescription : ""}
            </h1>

            <div className="row">
                <div className="col-6">
                    <DtGrid2 options={schedulesGridOptions} />
                    <br />
                    <div className="row"></div>
                </div>
                <div className="col-6">
                    <ReactSelectWrapper
                        data={ordersDropdownData}
                        isClearable={true}
                        styles={ReactSelectStyle}
                        onChange={x => {
                            let workorder = schedulesRedux.workorders.find(w => w.operationId === x.value);
                            if (!x || !workorder) {
                                dispatch(setSelectedScheduleRedux([]));
                                return;
                            }

                            let schedule = {
                                operationId: workorder.operationId,
                                scheduleOrder: 0,
                                siteId: workorder.siteId,
                                lineId: lineId,
                                startDateTime: aplSettings.isUsSite ? null : moment(workorder.startDate).toObject(),
                                endDateTime: null,
                                workorder: workorder.workorder,
                                workorderId: workorder.workorderId,
                                scheduleId: workorder.operationId
                            } as LineWoSchedule;
                            // console.log(`${new Date().toISOString()} - selected schedule from workorder`, schedule);
                            dispatch(setSelectedScheduleRedux([schedule]));
                            dispatch(setSelectedWorkorderRedux([workorder]));
                        }}
                        value={ordersDropdownData.find(x => x.value === schedulesRedux.selectedWorkorder[0]?.operationId) ?? null}
                        isDisabled={false}
                    />

                    <br />
                    {selectedSchedule ? (
                        <React.Fragment>
                            <label htmlFor="lineDescription">{translateString("line", aplSettings.culture)}</label>
                            <FormInputText
                                name="lineDescription"
                                value={aplSettings.lines.find(x => x.lineId === selectedSchedule.lineId)?.lineDescription ?? ""}
                                readOnly={true}
                            />
                            <label htmlFor="workorder">{translateString("workOrder", aplSettings.culture)}</label>
                            <FormInputText name="workorder" value={selectedSchedule.workorder} readOnly={true} />

                            {!aplSettings.isUsSite && (
                                <React.Fragment>
                                    <label htmlFor="startDate">{translateString("startDate", aplSettings.culture)}</label>
                                    <div className="input-group">
                                        <DateSelector3
                                            name="startDate"
                                            selectedDate={
                                                moment(selectedSchedule.startDateTime).isValid()
                                                    ? moment(selectedSchedule.startDateTime).toDate()
                                                    : null
                                            }
                                            onSetSelectedDate={e => {
                                                dispatch(setSelectedScheduleStartDateRedux(e));
                                            }}
                                            culture={aplSettings.culture}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn-primary"
                                                onClick={() => {
                                                    dispatch(setSelectedScheduleStartDateRedux(null));
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-x-square"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <label htmlFor="endDate">{translateString("endDate", aplSettings.culture)}</label>
                                    <div className="input-group">
                                        <DateSelector3
                                            name="endDate"
                                            selectedDate={
                                                moment(selectedSchedule.endDateTime).isValid()
                                                    ? moment(selectedSchedule.endDateTime).toDate()
                                                    : null
                                            }
                                            onSetSelectedDate={e => {
                                                dispatch(setSelectedScheduleEndDateRedux(e));
                                            }}
                                            culture={aplSettings.culture}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn-primary"
                                                onClick={() => {
                                                    dispatch(setSelectedScheduleEndDateRedux(null));
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-x-square"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <br />
                                </React.Fragment>
                            )}

                            <div className="float-right">
                                {aplSettings.isUsSite && (
                                    <React.Fragment>
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => {
                                                let lineWoSchedule = schedulesRedux.selectedSchedule[0];
                                                if (!lineWoSchedule) return;

                                                dispatch(changeScheduleOrderRedux({ schedule: lineWoSchedule, shift: -1 }));
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-arrow-up-square"
                                                viewBox="0 0 16 16"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V11.5z"
                                                />
                                            </svg>
                                        </button>
                                        &nbsp;
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => {
                                                let lineWoSchedule = schedulesRedux.selectedSchedule[0];
                                                if (!lineWoSchedule) return;

                                                dispatch(changeScheduleOrderRedux({ schedule: lineWoSchedule, shift: +1 }));
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                className="bi bi-arrow-down-square"
                                                viewBox="0 0 16 16"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                                                />
                                            </svg>
                                        </button>
                                        &nbsp;
                                    </React.Fragment>
                                )}
                                
                                <button
                                    className="btn btn-danger"
                                    onClick={() => {
                                        let lineWoSchedule = schedulesRedux.selectedSchedule[0];
                                        if (!lineWoSchedule) return;

                                        dispatch(deleteScheduleRedux(lineWoSchedule));
                                    }}
                                >
                                    {translateString("delete", aplSettings.culture)}
                                </button>
                                &nbsp;
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        let lineWoSchedule = schedulesRedux.selectedSchedule[0];
                                        if (!lineWoSchedule) return;

                                        navigate(`/workordermanagement/${lineWoSchedule.workorderId}`);
                                    }}
                                >
                                    {translateString("edit", aplSettings.culture)}
                                </button>
                                &nbsp;
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        let lineWoSchedule = schedulesRedux.selectedSchedule[0];
                                        if (!lineWoSchedule) return;

                                        console.log(`${new Date().toISOString()} - saving schedule`, lineWoSchedule);
                                        dispatch(saveScheduleRedux(lineWoSchedule));
                                    }}
                                >
                                    {translateString("save", aplSettings.culture)}
                                </button>
                            </div>
                        </React.Fragment>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
